(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ace-media-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ace-media-tabs')) {
    class AceMediaTabs extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        this.dataset.ready = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-ace-media-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-ace-media-panel]'));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index));
          tab.addEventListener('keydown', event => this.onKeydown(event, index));
        });

        this.activate(0, false);
      }

      onKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End'].includes(event.key)) return;

        event.preventDefault();
        let nextIndex = index;

        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % this.tabs.length;

        this.activate(nextIndex);
        this.tabs[nextIndex].focus();
      }

      activate(index, animate = true) {
        const update = () => {
          this.tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === index;
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.tabIndex = active ? 0 : -1;
          });

          this.panels.forEach((panel, panelIndex) => {
            const active = panelIndex === index;
            panel.hidden = !active;

            panel.querySelectorAll('iframe[data-src]').forEach(frame => {
              if (active && !frame.getAttribute('src')) frame.setAttribute('src', frame.dataset.src);
              if (!active && frame.getAttribute('src')) frame.removeAttribute('src');
            });

            panel.querySelectorAll('video').forEach(video => {
              if (active) video.play().catch(() => {});
              if (!active) video.pause();
            });
          });
        };

        if (animate && document.startViewTransition) {
          document.startViewTransition(update);
        } else {
          update();
        }
      }
    }

    customElements.define('ace-media-tabs', AceMediaTabs);
  }

  document.addEventListener('shopify:block:select', event => {
    const section = event.target.closest('ace-media-tabs');
    if (!section) return;

    const tab = section.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    if (!tab) return;

    tab.click();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('comparison-differences')) {
    class ComparisonDifferences extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="checkbox"]');
        this.chart = this.closest('feature-chart');
        this.rows = Array.from(this.chart?.querySelectorAll('[data-comparison-row]') || []);
        this.handleChange = this.updateRows.bind(this);
        this.input?.addEventListener('change', this.handleChange);
        this.updateRows();
      }

      disconnectedCallback() {
        this.input?.removeEventListener('change', this.handleChange);
      }

      updateRows() {
        const showOnlyDifferences = this.input?.checked === true;
        const chartIsExpanded = this.chart?.classList.contains('is-expanded') === true;

        this.rows.forEach((row) => {
          if (showOnlyDifferences) {
            row.hidden = row.dataset.hasDifferences !== 'true';
          } else {
            row.hidden = row.dataset.defaultHidden === 'true' && !chartIsExpanded;
          }
        });
      }
    }

    customElements.define('comparison-differences', ComparisonDifferences);
  }

  } catch(e) { console.error(e); }
})();
})();
